import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth, formatApiError } from "@/context/AuthContext";
import axios from "axios";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (isRegister) {
        const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
        await login(email, password);
        navigate("/mis-pedidos");
      } else {
        const data = await login(email, password);
        if (data.role === "admin") navigate("/admin");
        else navigate("/mis-pedidos");
      }
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-noir flex items-center justify-center px-6 grain-overlay relative" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md bg-noir-soft border border-white/10 px-10 py-14"
      >
        <div className="text-center mb-10">
          <Link to="/" data-testid="login-logo-link" className="font-serif-lux text-3xl tracking-[0.35em] text-white hover:text-gold transition-colors">MÉ</Link>
          <p className="text-[9px] uppercase tracking-[0.5em] text-neutral-500 mt-2">{isRegister ? "Crear cuenta" : "Acceso"}</p>
        </div>
        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          {isRegister && (
            <div>
              <label className="lux-label" htmlFor="login-name">Nombre</label>
              <input id="login-name" data-testid="login-name-input" type="text" required className="lux-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" />
            </div>
          )}
          <div>
            <label className="lux-label" htmlFor="login-email">Email</label>
            <input id="login-email" data-testid="login-email-input" type="email" required className="lux-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" />
          </div>
          <div>
            <label className="lux-label" htmlFor="login-password">Contraseña</label>
            <input id="login-password" data-testid="login-password-input" type="password" required className="lux-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p className="text-red-400 text-sm font-light" data-testid="login-error-message">{error}</p>}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="group relative w-full bg-gold text-black text-xs uppercase tracking-[0.3em] py-4 overflow-hidden disabled:opacity-50"
          >
            <span className="relative z-10 transition-colors duration-500 group-hover:text-gold">{loading ? "Procesando..." : (isRegister ? "Crear Cuenta" : "Entrar")}</span>
            <span className="absolute inset-0 bg-black translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
          </button>
        </form>
        <button onClick={() => setIsRegister(!isRegister)} className="w-full text-center text-[10px] uppercase tracking-[0.1em] text-neutral-400 hover:text-gold transition-colors mt-6 block">
          {isRegister ? "¿Ya tienes cuenta? Inicia sesión" : "¿No tienes cuenta? Regístrate"}
        </button>
        <Link to="/" data-testid="login-back-link" className="block text-center text-[10px] uppercase tracking-[0.3em] text-neutral-600 hover:text-gold transition-colors mt-8">
          Volver a la tienda
        </Link>
      </motion.div>
    </div>
  );
}
